import { createContext, useContext, useMemo, useState } from 'react';

const ColorPickerContext = createContext();

const INITIAL_STATE = Object.freeze({});

export const ColorPickerProvider = ({ children }) => {
  const [colorPickersOpen, setColorPickerOpen] = useState(INITIAL_STATE);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const externalControl = {
    enable: true,
    isPickerOpen: ({ id }) => Boolean(colorPickersOpen[id]),
    togglePicker: ({ forceClose, id }) =>
      setColorPickerOpen((prev) =>
        forceClose ? { [id]: false } : { [id]: !prev[id] },
      ),
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const resetAllColorPickers = () => setColorPickerOpen(INITIAL_STATE);

  const value = useMemo(
    () => ({
      externalControl,
      resetAllColorPickers,
    }),
    [externalControl, resetAllColorPickers],
  );

  return (
    <ColorPickerContext.Provider value={value}>
      {children}
    </ColorPickerContext.Provider>
  );
};

export const useColorPickerContext = () => useContext(ColorPickerContext);

export default ColorPickerContext;
